import {AuthClient} from "@dfinity/auth-client";
import {Identity} from "@dfinity/agent";

export class IIForIdentity {
  public authClient: AuthClient | undefined;
  public identity: Identity | undefined;

  constructor() {
    return this;
  }

  async create() {
    this.authClient = await AuthClient.create({
      idleOptions: {
        idleTimeout: 1000 * 60 * 30, // set to 30 minutes
        disableDefaultIdleCallback: true // disable the default reload behavior
      }
    });
  }

  //ii login
  async login() {
    return new Promise<any>(async (resolve, reject) => {
      this.authClient?.login({
        maxTimeToLive: BigInt(7 * 24 * 60 * 60 * 1000 * 1000 * 1000),
        onSuccess: async () => {
          this.identity = this.authClient?.getIdentity() as Identity | undefined;
          resolve(this.identity);
        },
        onError: (err) => {
          reject(err);
        },
      });
    });
  }

  //II
  async logout() {
    await this.authClient?.logout({returnTo: "/"});
    window.location.reload()
  }

  async getIdentity() {
    return this.authClient?.getIdentity();
  }

  async isAuthenticated() {
    return this.authClient?.isAuthenticated();
  }

  //II
  async checkLogin() {
    const authClient = await AuthClient.create();
    if (await authClient.isAuthenticated()) {
      this.authClient = authClient;
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
}

export const authClient = new IIForIdentity();
